import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Container, Row, Col, Button, Spinner } from 'react-bootstrap';
import { NumbersOnlyUtil } from '../../../utils';
import { DataContext } from '../../../adapter';
import styled from 'styled-components';
import validator from 'validator';
import {
    UploadedPolicyGetService,
    ClaimsGetService,
    ClaimTypeGetService,
    ClaimDocTypeGetService,
    DocPerClaimTypeGetService,
    OtpGenerateService,
    OtpValidateService
} from '../../../domain';
import { ShowPolicyView, ShowClaimsView } from './index';
import Swal from 'sweetalert2';
import OtpModalComponent from '../../components/modalOtp';

const StyledContainer = styled(Container)`
    font-family: 'Montserrat', sans-serif;
    color: rgba(41, 37, 97, 1);
    background: rgb(234, 222, 208, 1);
    padding: 20px 20%;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 100%;
        padding: 2% 10%;
    }
`;

const Title = styled.h1`
    font-size: 42px;
    font-weight: 700;
`;

const StyledRow = styled(Row)`
    padding: 6px 0;
`;

const Description = styled.p`
    font-size: 22px;
    font-weight: 500;
    padding: 5px 0px;
`;

const SubDescription = styled.p`
    font-size: 17px;
    font-weight: 400;
    // padding: 5px 0px;
`;

const RequiredTag = styled.span`
    color: red;
`;

const ErrorDisplay = styled.ul`
    color: red;
`;

const StyledForm = styled(Form)`
    .form-group-label {
        font-size: 22px;
        font-weight: 500;
        padding: 8px 0px;
    }
`;

const StyledSubmitButton = styled(Button)`
    background-color: rgba(176, 17, 22, 1);
    max-width: fit-content;
    padding: 5px 40px;
    border-radius: 25px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 20px;
    color: white;
    text-align: left;

    @media (min-width: 300px) and (max-width: 500px) {
        margin-bottom: 20px;
    }
`;

const Loading = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
`;

const InfoContainer = styled.div`
    position: relative;
    display: inline-block;
    cursor: pointer;

    &:hover .info-description {
        display: block;
    }
`;

const StyledDescription = styled.p`
    font-style: italic;
    font-size: 14px;
    color: black;
    display: none;
    position: absolute;
    background: rgba(255, 255, 255, 1);
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 500px;
    z-index: 100;
    top: -60px;
    left: -220px;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 300px;
        left: -140px;
        top: -95px;
    }
`;

const StyledDescription2 = styled.p`
    font-style: italic;
    font-size: 14px;
    color: black;
    display: none;
    position: absolute;
    background: rgba(255, 255, 255, 1);
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 550px;
    z-index: 100;
    top: -60px;
    left: -220px;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 300px;
        left: -100px;
        top: -95px;
    }
`;

export default function Home() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({});
    const [formDataError, setFormDataError] = useState(null);
    const { claimsData, updateClaimsData, clearClaimsData } = DataContext();
    const [modalOptions, setModalOptions] = useState({});
    const [loading, setLoading] = useState(false);
    const [claimTypes, setClaimTypes] = useState(null);
    const [docPerClaimTypes, setDocPerClaimTypes] = useState(null);
    const [isModalVisible, setModalVisible] = useState(false); // Modal visibility state
    const [response, setResponse] = useState(null);

    const _UploadedPolicyGetService = new UploadedPolicyGetService();
    const _ClaimsGetService = new ClaimsGetService();

    const _ClaimTypeGetService = new ClaimTypeGetService();
    const _ClaimDocTypeGetService = new ClaimDocTypeGetService();
    const _DocPerClaimTypeGetService = new DocPerClaimTypeGetService();

    const _OtpGenerateService = new OtpGenerateService();
    const _OtpValidateService = new OtpValidateService();

    // Function to handle OTP modal visibility
    const handleOpenModal = (response) => {
        setModalVisible(true);
        setResponse(response);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
        setResponse(null);
    };

    const validateFormData = async (type = null) => {
        const { loanAccountNumber, mobileNo, email } = formData;

        console.log('otp valid', claimsData?.otpData?.isOtpValidated);

        if (claimsData?.otpData?.isOtpValidated === undefined) {
            if (!loanAccountNumber && !mobileNo && !email) {
                Swal.fire({
                    text: 'Please provide at least Loan Account Number or Mobile Number and Email.',
                    icon: 'error',
                    iconColor: 'black',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                return { isValid: false };
            }

            if (formData.loanAccountNumber) {
                setLoading(true);

                const setOtpGeneratePayloadLAN = {
                    loanAccountNumber: formData.loanAccountNumber,
                    type: type
                };

                const response = await _OtpGenerateService.execute(setOtpGeneratePayloadLAN);
                // const response = await _UploadedPolicyGetService.execute(formData);
                if (response?.status === 'failed' && response?.message === 'No policy found.') {
                    Swal.fire({
                        html: 'Hindi namin mahanap ang iyong impormasyon sa aming records. Please check kung tama ang Loan Account Number o ang personal information na iyong ibinigay. Kung patuloy mong ma-encounter ang error, maaari kang mag-email sa <br /> <a href="mailto:BPIMS-Non-Motor_Claims@bpi.com.ph">BPIMS-Non-Motor_Claims@bpi.com.ph</a> para direktang i-file ang iyong claim.',
                        icon: 'info',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok',
                        customClass: {
                            popup: 'my-popup',
                            confirmButton: 'my-confirm-button',
                            cancelButton: 'my-cancel-button'
                        },
                        didOpen: () => {
                            Swal.getHtmlContainer().querySelector('a').style.color = '#3085d6';
                        }
                    }).then((result) => {
                        clearClaimsData();
                        setFormData({});
                    });
                    setLoading(false);
                    return { isValid: false };
                } else {
                    setLoading(false);
                    handleOpenModal({ response: response?.data });
                    return { isValid: true, isOtpValid: false };
                }
            }

            // Email and mobile number validation before checking multiple policies
            const emailValid = formData.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);
            const mobileValid = formData.mobileNo && /^\d{10}$/.test(formData.mobileNo);

            // Check if loan account number is correct, and either email or mobile number is missing
            const loanAccountValid = formData.loanAccountNumber && formData.loanAccountNumber > 0;
            const allowPassThrough = loanAccountValid && (!formData.email || !formData.mobileNo);

            // Case 1: Email is correct, mobile number is empty or incorrect length
            if (emailValid && !formData.mobileNo) {
                Swal.fire({
                    text: 'Please enter a valid 10-digit mobile number.',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                setFormData('');
                return { isValid: false };
            }

            // Case 2: Mobile number is correct, email is empty or invalid
            if (mobileValid && (!formData.email || !emailValid)) {
                Swal.fire({
                    text: 'Please enter a valid email address.',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                setFormData('');
                return { isValid: false };
            }

            // Case 3: Email and mobile number are both invalid
            if (!emailValid && !mobileValid) {
                Swal.fire({
                    text: 'Invalid email and mobile number. Please enter correct details.',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                setFormData('');
                return { isValid: false };
            }

            if (!allowPassThrough && !emailValid) {
                Swal.fire({
                    text: 'Please enter a valid email address.',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                setFormData('');
                return { isValid: false };
            }

            if (!allowPassThrough && !mobileValid) {
                Swal.fire({
                    text: 'Please enter a valid 10-digit mobile number.',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                setFormData('');
                return { isValid: false };
            }

            if (formData.mobileNo && formData.email) {
                setLoading(true);
                const setOtpPayload = {
                    email: formData.email,
                    mobileNo: formData.mobileNo,
                    type: type
                };

                const response = await _OtpGenerateService.execute(setOtpPayload);
                // const response = await _UploadedPolicyGetService.execute(formData);
                if (response?.status === 'failed' && response?.message === 'No policy found.') {
                    Swal.fire({
                        html: 'Hindi namin mahanap ang iyong impormasyon sa aming records. Please check kung tama ang Loan Account Number o ang personal information na iyong ibinigay. Kung patuloy mong ma-encounter ang error, maaari kang mag-email sa <br /> <a href="mailto:BPIMS-Non-Motor_Claims@bpi.com.ph">BPIMS-Non-Motor_Claims@bpi.com.ph</a> para direktang i-file ang iyong claim.',
                        icon: 'info',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok',
                        customClass: {
                            popup: 'my-popup',
                            confirmButton: 'my-confirm-button',
                            cancelButton: 'my-cancel-button'
                        },
                        didOpen: () => {
                            Swal.getHtmlContainer().querySelector('a').style.color = '#3085d6';
                        }
                    }).then((result) => {
                        clearClaimsData();
                        setFormData({});
                    });
                    setLoading(false);
                    return { isValid: false };
                } else {
                    setLoading(false);
                    handleOpenModal({ response: response?.data });
                    return { isValid: true, isOtpValid: false };
                }
            }

            return {
                isValid: true
            };
        } else {
            return {
                isValid: true
            };
        }
    };

    const handleFormSubmit = async (e, type = null) => {
        e.preventDefault();
        try {
            const { isValid } = await validateFormData(type);

            if (isValid && claimsData?.otpData?.isOtpValidated) {
                handleShowData();
            }
            console.log('isValid', isValid);
        } catch (error) {
            console.error('error occured: ', error);
            Swal.fire({
                text: 'Something went wrong. Please try again later.',
                icon: 'error',
                iconColor: 'black',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
            setLoading(false);
        }
    };

    // must add value in localStorage...
    const handleOtpSubmit = async (type, otp) => {
        try {
            let setOtpValidatePayload;
            if (formData?.loanAccountNumber) {
                setOtpValidatePayload = {
                    loanAccountNumber: formData?.loanAccountNumber,
                    type,
                    otp
                };
            } else {
                setOtpValidatePayload = {
                    email: formData?.email,
                    mobileNo: formData?.mobileNo,
                    type,
                    otp
                };
            }

            const otpResult = await _OtpValidateService.execute(setOtpValidatePayload);

            return otpResult;
        } catch (error) {
            console.error('error occured: ', error);
            Swal.fire({
                text: 'Something went wrong. Please try again later.',
                icon: 'error',
                iconColor: 'black',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
        }
    };

    const handleShowData = async (response) => {
        try {
            // has selected policy
            if (formData?.selectedPolicy) {
                // has no selected specific claims
                if (formData?.createNewClaim || formData?.selectedClaim === 'create new claim') {
                    updateClaimsData(formData);
                    navigate('/selection');
                    return;
                }

                // has selected specific claims
                if (typeof formData?.selectedClaim === 'number') {
                    updateClaimsData(formData);
                    navigate('/details');
                    return;
                }
            }

            // has multiple available policy but doenst have a specific selected policy
            if (formData.availablePolicy && !formData?.selectedPolicy) {
                Swal.fire({
                    text: 'Please select a Policy.',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                return;
            }

            // has selected policy but dont have selected claim
            if (formData?.selectedPolicy && !formData?.selectedClaim) {
                Swal.fire({
                    text: 'Please select a Claim or create a new one.',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                return;
            }

           
            // filter the policies with inception date that is not greater than the current date
            const  filteredPolicies = response?.data?.uploadedPolicies.filter(
                (policy) => new Date(policy.inceptionDate) <= new Date()
            );

            // show modal if the policy result is multiple
            if (filteredPolicies.length > 1) {
                Swal.fire({
                    text: 'You have multiple existing policies in our database. Please select which specific policy you are claiming for before proceeding.',
                    icon: 'info',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        setModalOptions({ showModal: false });
                        setFormData({
                            ...formData,
                            availablePolicy: filteredPolicies,
                            availablePolicyPagination: {
                                totalData: response.data.totalData,
                                totalPage: response.data.totalPage,
                                currentPage: response.data.currentPage
                            }
                        });
                    }
                });
                setLoading(false);
                return;
            }

            // the code block below will trigger if the policy result is only one.
            const singlePolicyResult = filteredPolicies[0];

            const claims = await bindAvailableClaims(singlePolicyResult.id);
            console.log('claims: ', claims);
            const { customerDetails, ...policyCustomerDetails } = singlePolicyResult;

            setFormData({
                ...formData,
                availablePolicy: filteredPolicies,
                availablePolicyPagination: {
                    totalData: response.data.totalData,
                    totalPage: response.data.totalPage,
                    currentPage: response.data.currentPage
                },
                selectedPolicy: filteredPolicies[0].id,
                availableClaims: claims.claims,
                availableClaimsPagination: {
                    totalData: claims.totalData,
                    totalPage: claims.totalPage,
                    currentPage: claims.currentPage
                },
                selectedClaim: claims.claims.length ? undefined : 'create new claim',
                createNewClaim: false,
                claimsPayload: {
                    refId: filteredPolicies[0].id,
                    refTable: 'txn_uploaded_policy',
                    status: 'Pending',
                    customerDetails: {
                        ...customerDetails,
                        ...policyCustomerDetails
                    }
                },
                docPerClaimTypes: docPerClaimTypes
            });
            setLoading(false);
        } catch (error) {
            console.error('Error: ', error);
            Swal.fire({
                html: 'Hindi namin mahanap ang iyong impormasyon sa aming records. Please check kung tama ang Loan Account Number o ang personal information na iyong ibinigay. Kung patuloy mong ma-encounter ang error, maaari kang mag-email sa <br /> <a href="mailto:BPIMS-Non-Motor_Claims@bpi.com.ph">BPIMS-Non-Motor_Claims@bpi.com.ph</a> para direktang i-file ang iyong claim.',
                icon: 'info',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                },
                didOpen: () => {
                    Swal.getHtmlContainer().querySelector('a').style.color = '#3085d6';
                }
            });
            setLoading(false);
            // setFormData({});
            handleCloseModal();
        }
    };

    const bindAvailableClaims = async (id, page = null) => {
        try {
            console.log('bindAvailableClaims id, page:', id, page);
            const claims = await _ClaimsGetService.execute({ id, page });

            return claims;
        } catch (error) {
            console.error('error occured: ', error);
            Swal.fire({
                text: 'Something went wrong. Please try again later.',
                icon: 'error',
                iconColor: 'black',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
            setLoading(false);
        }
    };

    const mapDocumentPerClaimType = async () => {
        try {
            setLoading(true);
            const [docPerClaimTypes, claimTypes, documentTypes] = await Promise.all([
                _DocPerClaimTypeGetService.execute(),
                _ClaimTypeGetService.execute(),
                _ClaimDocTypeGetService.execute()
            ]);

            if (!docPerClaimTypes.documentPerClaimTypes || !claimTypes.claimTypes || !documentTypes.documentTypes) {
                Swal.fire({
                    text: 'Something went wrong. Please try again later.',
                    icon: 'error',
                    iconColor: 'black',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                return;
            }
            setClaimTypes(claimTypes.claimTypes);

            // map the data
            const result = docPerClaimTypes.documentPerClaimTypes.map((docPerClaim) => {
                const claimType = claimTypes.claimTypes.find((claim) => claim.id === docPerClaim.mtnClaimTypeId);
                const documentType = documentTypes.documentTypes.find(
                    (doc) => doc.id === docPerClaim.mtnDocumentTypeId
                );

                return {
                    id: docPerClaim.id,
                    mtnClaimTypeId: docPerClaim.mtnClaimTypeId,
                    mtnDocumentTypeId: docPerClaim.mtnDocumentTypeId,
                    claimTypeDesc: claimType ? claimType.claimTypeDesc : null,
                    claimTypeCd: claimType ? claimType.claimTypeCd : null,
                    documentDesc: documentType ? documentType.documentDesc : null
                };
            });
            // console.log(result);

            setDocPerClaimTypes(result);

            setLoading(false);
        } catch (error) {
            Swal.fire({
                text: 'Something went wrong. Please try again later.',
                icon: 'error',
                iconColor: 'black',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
            console.error('Error:', error);
            setLoading(false);
        }
    };

    const policyTablePageChange = async (page = null) => {
        try {
            let policySetPayload;
            if (formData?.loanAccountNumber) {
                policySetPayload = {
                    loanAccountNumber: formData.loanAccountNumber,
                    page
                };
            } else {
                policySetPayload = {
                    mobileNo: formData.mobileNo,
                    email: formData.email,
                    page
                };
            }

            console.log('policySetPayload: ', policySetPayload);
            console.log('formData: ', formData);

            const policyResponse = await _UploadedPolicyGetService.execute(policySetPayload);
            console.log('policyResponse', policyResponse);

            return policyResponse;
        } catch (error) {
            console.error('error occured: ', error);
            Swal.fire({
                text: 'Something went wrong. Please try again later.',
                icon: 'error',
                iconColor: 'black',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
            setLoading(false);
        }
    };

    useEffect(() => {
        mapDocumentPerClaimType();
        if (Object.keys(claimsData).length === 1 && Object.keys(claimsData)[0] === 'otpData') {
            clearClaimsData();
        }

        if (Object.keys(claimsData).length) {
            setFormData({ ...claimsData });
        }
    }, []);

    return (
        <>
            {loading && (
                <Loading>
                    <Spinner animation="border" variant="light" />
                </Loading>
            )}
            <StyledContainer id="claim" fluid>
                <StyledRow>
                    <Title>File a Claim</Title>
                    <SubDescription>
                        <strong>Paalala:</strong> Make sure na mag-file ng claim pagkatapos agad ng nangyaring sakuna,
                        para hindi siya maging dahilan ng pagka-deny o pagkabale-wala nito. Hindi kinakailangang
                        kumpleto agad ang documents sa pag-file ng claim. Mahalagang maipaalam agad ito sa kinauukulan.
                    </SubDescription>
                </StyledRow>
                <StyledForm>
                    {formDataError && (
                        <Row>
                            <Col>
                                <Description className="mb-0">Please check the inputs again.</Description>
                                <ErrorDisplay>
                                    {formDataError &&
                                        formDataError.map((item, index) => {
                                            return <li key={'errorKey_' + index}>{item.message}</li>;
                                        })}
                                </ErrorDisplay>
                            </Col>
                        </Row>
                    )}
                    <Row className="mb-4">
                        <Col lg={5}>
                            <Description>
                                Provide your Loan Account Number:
                                <InfoContainer>
                                    &nbsp;<i className="bi bi-info-circle" style={{ padding: '2px', fontSize: '18px' }}></i>
                                    <StyledDescription2 className="info-description">
                                        How to check your Loan Account Number: Open your Home Credit App &gt; Go to the
                                        "Home" tab &gt; Go to "My Loans" to find your 10-digit Loan Account Number
                                    </StyledDescription2>
                                </InfoContainer>
                            </Description>
                            <Form.Group>
                                <Col className="form-group-label">
                                    LOAN ACCOUNT NUMBER<RequiredTag> *</RequiredTag>
                                </Col>
                                <Form.Control
                                    type="text"
                                    size="lg"
                                    name="loanAccountNumber"
                                    placeholder="LOAN ACCOUNT NUMBER"
                                    value={formData.loanAccountNumber ?? ''}
                                    onChange={(e) =>
                                        setFormData((val) => ({
                                            ...val,
                                            loanAccountNumber: NumbersOnlyUtil(e.target.value)
                                        }))
                                    }
                                    isValid={formData.loanAccountNumber && formData.loanAccountNumber.length >= 1}
                                    isInvalid={formData.loanAccountNumber && formData.loanAccountNumber.length < 1}
                                    disabled={formData?.availablePolicy}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Description>OR:</Description>
                            <Description className="mb-0">
                                Provide your email address & mobile number:
                                <InfoContainer>
                                    &nbsp;<i className="bi bi-info-circle" style={{ padding: '2px', fontSize: '18px' }}></i>
                                    <StyledDescription className="info-description">
                                        Please ensure that it matches the details used in your application. Pakisigurado
                                        na tugma ito sa mga detalye na ginamit sa iyong application.
                                    </StyledDescription>
                                </InfoContainer>
                            </Description>
                            {/* <SubDescription>
                                <b>Please ensure that it matches the details used in your application.</b>
                                <br />
                                <i>Pakisigurado na tugma ito sa mga detalye na ginamit sa iyong application.</i>
                            </SubDescription> */}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col lg={4}>
                            <Form.Group className="mb-3">
                                <Col className="form-group-label">
                                    MOBILE NO.<RequiredTag> *</RequiredTag>
                                </Col>
                                <div className="input-group">
                                    <span
                                        className="input-group-text custom-input"
                                        style={{
                                            border: formData.mobileNo
                                                ? formData.mobileNo.length === 10
                                                    ? '1px solid green'
                                                    : '1px solid red'
                                                : ''
                                        }}
                                    >
                                        +63
                                    </span>
                                    <Form.Control
                                        type="text"
                                        size="lg"
                                        name="mobileNumber"
                                        placeholder="917XXXXXXX"
                                        value={formData.mobileNo ?? ''}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Remove non-numeric characters and ensure it's exactly 10 digits
                                            const cleanedValue = value.replace(/\D/g, '');
                                            setFormData((val) => ({
                                                ...val,
                                                mobileNo: cleanedValue.substring(0, 10) // Enforce a maximum length of 10 digits
                                            }));
                                        }}
                                        isValid={formData.mobileNo && formData.mobileNo.length === 10}
                                        isInvalid={formData.mobileNo && formData.mobileNo.length !== 10}
                                        disabled={formData?.availablePolicy}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group className="mb-3">
                                <Col className="form-group-label">
                                    EMAIL<RequiredTag> *</RequiredTag>
                                </Col>
                                <Form.Control
                                    type="email"
                                    size="lg"
                                    name="email"
                                    placeholder="Email@Address.com"
                                    value={formData.email ?? ''}
                                    onChange={(e) => setFormData((val) => ({ ...val, email: e.target.value }))}
                                    isValid={formData.email && validator.isEmail(formData.email)}
                                    isInvalid={formData.email && !validator.isEmail(formData.email)}
                                    disabled={formData?.availablePolicy}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {formData?.availablePolicy && !!formData.availablePolicy.length && !modalOptions?.showModal && (
                        <Row>
                            <Col>
                                <ShowPolicyView
                                    formData={formData}
                                    setFormData={setFormData}
                                    setLoading={setLoading}
                                    bindAvailableClaims={bindAvailableClaims}
                                    docPerClaimTypes={docPerClaimTypes}
                                    policyTablePageChange={policyTablePageChange}
                                />
                            </Col>
                        </Row>
                    )}

                    {formData?.availableClaims && !!formData.availableClaims.length && !modalOptions?.showModal && (
                        <Row>
                            <Col>
                                <ShowClaimsView
                                    formData={formData}
                                    setFormData={setFormData}
                                    setLoading={setLoading}
                                    claimTypes={claimTypes}
                                    claimsData={claimsData}
                                    docPerClaimTypes={docPerClaimTypes}
                                    updateClaimsData={updateClaimsData}
                                    handleFormSubmit={handleFormSubmit}
                                    bindAvailableClaims={bindAvailableClaims}
                                />
                            </Col>
                        </Row>
                    )}

                    <Row>
                        <div className="gap-2 justify-content-left mt-2">
                            {!!Object.keys(formData).length && (
                                <StyledSubmitButton
                                    className="btn-submit me-2"
                                    variant="secondary"
                                    type="button"
                                    onClick={(e) => {
                                        setFormData({});
                                        setFormDataError(null);
                                        clearClaimsData();
                                    }}
                                >
                                    CLEAR
                                </StyledSubmitButton>
                            )}
                            <StyledSubmitButton
                                className="btn-submit me-2"
                                variant="secondary"
                                type="button"
                                onClick={(e) => {
                                    handleFormSubmit(e);
                                }}
                            >
                                NEXT
                            </StyledSubmitButton>
                        </div>
                    </Row>
                </StyledForm>
                <OtpModalComponent
                    showModal={isModalVisible}
                    onClose={handleCloseModal}
                    response={response}
                    formData={formData}
                    setFormData={setFormData}
                    handleFormSubmit={handleFormSubmit}
                    handleOtpSubmit={handleOtpSubmit}
                    handleShowData={handleShowData}
                    setLoading={setLoading}
                    claimsData={claimsData}
                    updateClaimsData={updateClaimsData}
                />
            </StyledContainer>
        </>
    );
}
